import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

import {BlobViewContent} from '../components/BlobViewContent'
import {BlobBanners} from '../components/CodeViewBanners'
import {useCodeNav} from '../contexts/CodeNavContext'
import {useTreePaneContext} from '../contexts/TreePaneContext'
import {useCurrentBlob} from '../hooks/CurrentBlob'
import {codeViewBlobLayoutRoute} from '../routes/code-view-blob-layout-route'
import {codeViewLayoutRoute} from '../routes/code-view-layout-route'
import {CodeView} from './CodeView'

export function CodeViewBlobEntrypoint() {
  const {data: blobLayoutPayload} = useRouteQuery(codeViewBlobLayoutRoute, 'mainQuery')
  const {data: layoutPayload} = useRouteQuery(codeViewLayoutRoute, 'mainQuery')

  const {isTreeExpanded, treeToggleElement} = useTreePaneContext()
  const {validCodeNav, setValidCodeNav} = useCodeNav()
  const blob = useCurrentBlob()

  return (
    <CodeView payload={blobLayoutPayload} action="blob">
      {() => (
        <>
          {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
          <div className="react-code-view-bottom-padding">
            <BlobBanners />
          </div>
          <BlobViewContent
            blob={blob}
            symbolsExpanded={layoutPayload.symbolsExpanded}
            setValidCodeNav={setValidCodeNav}
            showTree={isTreeExpanded}
            treeToggleElement={treeToggleElement}
            validCodeNav={validCodeNav}
            copilotInfo={blobLayoutPayload.copilotInfo}
          />
        </>
      )}
    </CodeView>
  )
}
